/*
 * @Author: zyl zhuoyl@126.com
 * @Date: 2024-10-17 10:17:37
 * @LastEditors: zyl zhuoyl@126.com
 * @LastEditTime: 2024-10-25 10:13:52
 * @FilePath: \ClassAssistantd:\HBuilderProjects\class-assistant-pc\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import AutoLogin from '@/components/AutoLogin'
import Classroom from '@/components/Classroom'
import ResourceList from '@/components/ResourceList'
import ResourceDetail from '@/components/ResourceDetail'
import Detail from '@/components/Detail'
import LiveList from '@/components/LiveList'
import pcVideo from '@/components/pcVideo'

Vue.use(Router)

const router= new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/pcVideo',
      name: 'pcVideo',
      component: pcVideo,
    },
    {
      path: '/aLogin',
      name: 'AutoLogin',
      component: AutoLogin
    },
    {
      path: '/Classroom',
      name: 'Classroom',
      component: Classroom,
      redirect: 'ResourceList',
      children: [
        {
          path: '/ResourceList',
          name: 'ResourceList',
          component: ResourceList,
        }, {
          path: '/ResourceDetail',
          name: 'ResourceDetail',
          component: resolve => require(['@/components/ResourceDetail.vue'], resolve),
        },{
          path: '/Detail',
          name: 'Detail',
          component:resolve => require(['@/components/Detail.vue'], resolve),
        },{
          path: '/Students',
          name: 'Students',
          component:resolve => require(['@/components/Students.vue'], resolve),
        },{
          path: '/Student',
          name: 'Student',
          component:resolve => require(['@/components/Student.vue'], resolve),
        },{
          path: '/LiveList',
          name: 'LiveList',
          component:resolve => require(['@/components/LiveList'], resolve),
        },
        {
          path: '/StudentTaskDetail',
          name: 'StudentTaskDetail',
          component:resolve => require(['@/components/StudentTaskDetail'], resolve),
        }
      ]
    }
  ],scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

/*
NavigationDuplicated 错误通常发生在 Vue Router 尝试导航到一个与当前路由完全相同的地址时。在 Vue Router 3.x 版本中，这会导致一个错误，但在 Vue Router 4 (适用于 Vue 3) 中，这种行为已被修改，不再抛出错误，而是返回一个失败的导航结果。
为了避免 NavigationDuplicated 错误，你可以在导航之前检查目标路由是否与当前路由相同。如果是，则不进行导航操作。
*/
router.beforeEach((to, from, next) => {
  if (to.name === from.name && JSON.stringify(to.query) === JSON.stringify(from.query)) {
    // 导航到相同的路由，阻止路由跳转
    next(false);
  } else {
    next();
  }
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js